import React from "react";
import { Typography as TypographyBase } from "@mui/material";
import Theme from "../../themes/theme";
import { useTheme } from "@mui/styles";

function getColor(
  color: string = "black",
  theme?: Theme,
  brightness: string = "main"
) {
  if (color && theme.palette[color] && theme.palette[color][brightness]) {
    return theme.palette[color][brightness];
  }
}

function getFontWeight(style: string) {
  switch (style) {
    case "light":
      return 300;
    case "medium":
      return 500;
    case "bold":
      return 700;
    default:
      return 400;
  }
}

function getFontSize(size?: string, variant: string = "", theme?: any) {
  let multiplier: number;

  switch (size) {
    case "sm":
      multiplier = 0.8;
      break;
    case "md":
      multiplier = 1.5;
      break;
    case "xl":
      multiplier = 2;
      break;
    case "xxl":
      multiplier = 3;
      break;
    default:
      multiplier = 1;
      break;
  }

  const defaultSize =
    variant && theme.typography[variant]
      ? theme.typography[variant].fontSize
      : theme.typography.fontSize + "px";

  return `calc(${defaultSize} * ${multiplier})`;
}

export function Typography({
  children,
  weight = undefined,
  size = undefined,
  colorBrightness = undefined,
  color = undefined,
  ...props
}) {
  const theme: Theme = useTheme();

  return (
    <TypographyBase
      style={{
        color: getColor(color, theme, colorBrightness),
        fontWeight: getFontWeight(weight),
        fontSize: getFontSize(size, props.variant, theme),
      }}
      {...props}
    >
      {children}
    </TypographyBase>
  );
}
